/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSlides } from "../../services/slide";
import { uiAction } from "../../store/ui-gemini";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Slide = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dontShow, setDontShow] = useState(false);
  const [entered, setEntered] = useState(false);
  const [loadedIds, setLoadedIds] = useState(new Set());
  const [currentIndex, setCurrentIndex] = useState(0);
  const dispatch = useDispatch();
  const isShowSlide = useSelector((state) => state.ui.isShowSlide);

  const close = () => {
    dispatch(uiAction.toggleSlide());
  };

  const onSetDontShow = () => {
    setDontShow((v) => !v);
    if (!dontShow) {
      localStorage.setItem("hslide", "true");
    } else {
      localStorage.setItem("hslide", "false");
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const dataSlides = await getSlides();
        setData(dataSlides?.data?.data || []);
      } catch (error) {
        // If unauthenticated (guest), gracefully skip showing slides
        if (error?.response?.status === 401) {
          setData([]);
        } else {
          // Optional: log other errors for debugging
          // console.error('Failed to load slides:', error);
          setData([]);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (isShowSlide) {
      const id = requestAnimationFrame(() => setEntered(true));
      return () => cancelAnimationFrame(id);
    }
    setEntered(false);
  }, [isShowSlide]);

  useEffect(() => {
    if (data.length > 0 && currentIndex >= data.length) {
      setCurrentIndex(0);
    }
  }, [data, currentIndex]);

  const items = (data || []).slice(0, 4);
  const hasItems = items.length > 0;

  return (
    isShowSlide &&
    data?.length > 0 && (
      <div onClick={close}>
        <div className={`modal flex overflow-y-auto overflow-x-hidden fixed inset-0 z-[6] justify-center items-center transition-opacity duration-300 ${entered ? "bg-gray-700 bg-opacity-75 opacity-100" : "bg-gray-700 bg-opacity-75 opacity-0"}`}>
          <div
            className="relative sm:mx-2 max-h-[720px] max-w-[90vw] md:max-w-[1100px] lg:max-w-[1400px]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              aria-label="Close"
              onClick={close}
              className="absolute -top-3 -right-3 z-10 rounded-full bg-black/60 text-white hover:bg-black/80 transition px-3 py-1"
            >
              ×
            </button>
            <div className={` w-full flex flex-col items-center transition-all duration-300 ease-out ${entered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
              <div className="w-full p-4">
                {/* Mobile: carousel centered, image fits slide (contain) */}
                <div className="block md:hidden">
                  {hasItems && (
                    <div className="w-full max-h-[72vh]">
                      <Carousel
                        className="h-full"
                        selectedItem={currentIndex}
                        onChange={(index) => setCurrentIndex(index)}
                        onClickItem={(index, item) => {
                          const slide = items[index];
                          if (slide?.link) {
                            window.open(slide.link, "_blank", "noopener,noreferrer");
                          }
                        }}
                        showThumbs={false}
                        showStatus={false}
                        emulateTouch
                        swipeable
                        infiniteLoop
                        useKeyboardArrows
                        showArrows
                        dynamicHeight={false}
                        renderIndicator={(onClickHandler, isSelected, index, label) => (
                          <li
                            key={index}
                            aria-label={label}
                            onClick={(e) => {
                              e.stopPropagation();
                              onClickHandler();
                            }}
                            className={`inline-block mx-1 w-2.5 h-2.5 rounded-full ${isSelected ? "bg-gray-800 dark:bg-gray-200" : "bg-gray-300 dark:bg-gray-600"}`}
                          />
                        )}
                      >
                        {items.map((item) => (
                          <div key={item._id} className="h-full flex items-center justify-center bg-transparent">
                            <img
                              src={item.url}
                              alt={`slide-${item._id}`}
                              onLoad={() => setLoadedIds((prev) => new Set(prev).add(item._id))}
                              onError={() => setLoadedIds((prev) => new Set(prev).add(item._id))}
                              className="block max-w-full max-h-full object-contain"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </div>
                  )}
                </div>

                {/* Desktop: keep existing 4-column grid */}
                <div className="hidden md:block">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {items.map((item) => (
                      <div key={item._id} className="w-full">
                        <img
                          onClick={() => window.open(item.link, "_blank")}
                          src={item.url}
                          alt={`slide-${item._id}`}
                          onLoad={() => setLoadedIds((prev) => new Set(prev).add(item._id))}
                          onError={() => setLoadedIds((prev) => new Set(prev).add(item._id))}
                          className={`rounded cursor-pointer mx-auto w-full h-64 sm:h-56 md:h-64 lg:h-80 object-cover transition-opacity duration-700 ease-out ${loadedIds.has(item._id) ? "opacity-100" : "opacity-0"}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <input
                  id="dont-show"
                  type="checkbox"
                  checked={dontShow}
                  onChange={onSetDontShow}
                  className="mr-2 cursor-pointer"
                />
                <label
                  htmlFor="dont-show"
                  className="text-gray-700 pb-1 dark:text-gray-200  cursor-pointer"
                >
                  Don't show this again
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Slide;
